module.exports = __webpack_public_path__ + "img/amyelsner.36e3fb4e.png";